import { render } from "./educacao-infantil.vue?vue&type=template&id=0a5b549e"
import script from "./educacao-infantil.vue?vue&type=script&lang=js"
export * from "./educacao-infantil.vue?vue&type=script&lang=js"

import "./educacao-infantil.vue?vue&type=style&index=0&id=0a5b549e&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__